/** Creates an empty personSubmission. Can also be used to check person schema. */
const personSubmission = () => ({
  awards: '',
  bio: '',
  bonus: '',
  curateInterest: '',
  identities: {},
  name: '',
  photo: '',
  pronouns: '',
  title: 'author',
  website: null,
})

export default personSubmission
